import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { sidenavIsPinnedState } from '../../../storage/app';
import { streamingCurrentStateState, streamingState } from '../../../storage/streaming';
import CurrentStateActionModals from '../../currentState/modal/CurrentStateActionModals';
import StreamingDetail from '../../currentState/streaming/StreamingDetail';
import FloatingStreamingWindow from '../../currentState/streaming/shared/FloatingStreamingWindow';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';

function StreamPage() {
  const { theme } = useStyles();
  const streamingCurrentState = useRecoilValue(streamingCurrentStateState);
  const setStreaming = useSetRecoilState(streamingState);
  const resetStreaming = useResetRecoilState(streamingState);
  const setSidenavIsPinned = useSetRecoilState(sidenavIsPinnedState);
  const { zoomTo } = useCamera();
  const { ident } = useParams();

  useEffect(() => {
    return () => {
      resetStreaming();
    };
  }, []);

  useEffect(() => {
    setSidenavIsPinned(false);
  }, []);

  useEffect(() => {
    setStreaming((prev) => ({
      ...prev,
      ident,
    }));
  }, [ident]);

  useEffect(() => {
    if (streamingCurrentState) {
      const lng = streamingCurrentState.point.coordinates[0];
      const lat = streamingCurrentState.point.coordinates[1];
      if (lng && lat) zoomTo({ lng, lat });
    }
  }, [streamingCurrentState, zoomTo]);

  return (
    <>
      <FloatingCardsLayout
        contentSize={400}
        content={
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
          >
            <StreamingDetail />
          </FloatingCardContent>
        }
      />
      <FloatingStreamingWindow />
      <CurrentStateActionModals />
    </>
  );
}

export default StreamPage;
